<sortable-item
  draggable="{ props.dragMode && 'true' }" 
  ondragstart="{ onDragStart }"
  ondragenter="{ onDragOver }"
  ondragover="{ onDragOver }"
  ondragend="{ onDragEnd }" 
  data-id="{ props.dataId }">
  <slot />
  <script>

    const getIndexOfElement = (el, childrenIn) => {
      if (!el || !el.parentNode)
        return -1;
      const children = childrenIn ?? Array.from(el.parentNode.childNodes);
      const index = children.indexOf(el);
      return index;
    };
    
    const animationDelay = 150;
    const checkRange = 3;

    export default {
      onDragStart(e) {
        if (!this.props.dragMode || e.target == null || e.target.style == null) {
          return;
        }
        e.target.style.opacity = '.1';
        this.props.shadow.onChange(e.target);
        this.props.shadow.setStartIndex(getIndexOfElement(e.target));
      },

      onDragOver(e) {
        e.preventDefault();
        const shadow = this.props.shadow?.getElement();
        if (!this.props.dragMode || shadow == null) {
          return;
        }
        const height = shadow.clientHeight;
        const overElement = e.currentTarget;
        const children = Array.from(shadow.parentNode?.childNodes ?? []);
        const pIndex = getIndexOfElement(overElement, children);
        const sIndex = getIndexOfElement(shadow, children);
        if (pIndex === -1 || sIndex === -1) {
          return;
        }

        const startIndex = this.props.shadow.getStartIndex();
        
        if (this.props.shadow.stateMode) {
          this.props.shadow.setEndIndex(pIndex);
          for (
            let i = pIndex - checkRange; 
            i < pIndex + checkRange + 1; 
            ++i
          ) {
            const el = children[i];
            if (!el || el.style == null)
              continue;
            requestAnimationFrame(() => {
              el.style.transition = `transform ease ${animationDelay}ms`;
              if (pIndex < startIndex && i >= pIndex && i < startIndex)
                el.style.transform = `translateY(${height}px)`;
              else if (pIndex > startIndex && i > startIndex && i <= pIndex)
                el.style.transform = `translateY(-${height}px)`;
              else
                el.style.transform = '';
            });
          }
          return;
        }

        requestAnimationFrame(() => {
          overElement.style.transition = `transform ease ${animationDelay}ms`;
          this.props.shadow.setEndIndex(pIndex);
          if (pIndex > sIndex) {
            overElement.style.transform = `translateY(-${height}px)`;
            setTimeout(() => {
              overElement.style.transition = '';
              overElement.style.transform = '';
              overElement.parentNode?.insertBefore(shadow, overElement.nextSibling);
            }, animationDelay);
          } else if (pIndex !== sIndex) {
            overElement.style.transform = `translateY(${height}px)`;
            setTimeout(() => {
              overElement.style.transition = '';
              overElement.style.transform = '';
              overElement.parentNode?.insertBefore(shadow, overElement);
            }, animationDelay);
          }
        });
      },

      onDragEnd() {
        if (!this.props.dragMode) {
          return;
        }
        const shadow = this.props.shadow?.getElement();
        if (shadow) {
          shadow.style.opacity = '1';
          const eventData = {
            startIndex: this.props.shadow.getStartIndex(),
            endIndex: this.props.shadow.getEndIndex(),
            targetElement: shadow,
          };
          const e = new CustomEvent('change', { detail: eventData });
          if (this.props.shadow.stateMode) {
            const children = Array.from(shadow.parentNode.childNodes);
            for (
              let i = Math.min(eventData.startIndex, eventData.endIndex) - checkRange; 
              i <= Math.max(eventData.startIndex, eventData.endIndex) + checkRange;
              ++i
            ) {
              if (!children[i] || children[i].style == null)
                continue;
              requestAnimationFrame(() => {
                children[i].style.transition = '';
                children[i].style.transform = '';
              });
            }
          }
          this.props.shadow.getContainer().dispatchEvent(e);
        }
        this.props.shadow?.onChange(null);
        this.props.shadow?.setStartIndex(-1);
        this.props.shadow?.setEndIndex(-1);
      }
    };
  </script>
</sortable-item>